import LegalShell, { LegalSection } from './LegalShell';

export default function PrivacyPage() {
  return (
    <LegalShell testId="privacy-page" eyebrow="Legal" title="Privacy Notice">
      <LegalSection n="1" title="Who we are">
        <p>
          PNC UNIQUE LTD (&ldquo;PNC&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) is the data controller for personal
          information processed through this contract e-signature portal. We are registered in England and Wales,
          with our registered office at Headlands House, 1 Kings Court, Kettering Parkway, Kettering,
          Northamptonshire, NN15 6WJ. Our ICO registration number is <strong>ZB865873</strong>.
        </p>
        <p>
          This notice explains how we handle your personal data when you are invited to sign a contract for
          services, opt in to a PNC service (weekly invoice creation or insurance cover), or complete a
          health &amp; safety acknowledgement through this portal.
        </p>
      </LegalSection>

      <LegalSection n="2" title="What we collect">
        <ul>
          <li><strong>Identity data</strong> — your full name, business/company name, and the capacity in which you sign.</li>
          <li><strong>Contact data</strong> — the email address your invitation was sent to.</li>
          <li><strong>Signature data</strong> — the electronic signature you draw when accepting an agreement.</li>
          <li><strong>Response data</strong> — whether you accepted or declined a service request, and any acknowledgements you confirm (for example, Tool Box Talk sections and Site Rules).</li>
          <li><strong>Technical data</strong> — the IP address and browser user-agent recorded at the moment you submit, used for audit and fraud prevention.</li>
        </ul>
        <p>We do not collect payment card details, passwords or special category data through this portal, other than health &amp; safety acknowledgements you choose to give.</p>
      </LegalSection>

      <LegalSection n="3" title="Why we process your data (lawful bases)">
        <ul>
          <li><strong>Performance of a contract</strong> (UK GDPR Art. 6(1)(b)) — creating, signing and storing your contract for services and any service opt-ins.</li>
          <li><strong>Legal obligation</strong> (Art. 6(1)(c)) — retaining health &amp; safety acknowledgements and contractual records we are required to keep.</li>
          <li><strong>Legitimate interests</strong> (Art. 6(1)(f)) — maintaining an accurate audit trail of who signed what and when, including IP and timestamp evidence, to protect both parties in the event of a dispute.</li>
        </ul>
      </LegalSection>

      <LegalSection n="4" title="Who we share your data with">
        <ul>
          <li><strong>Google Firebase (Google Cloud)</strong> — secure document storage and database hosting in the europe-west2 (London) region.</li>
          <li><strong>Resend</strong> — our transactional email provider, used to deliver signing invitations and completed documents to PNC HR.</li>
          <li><strong>PNC HR staff</strong> — authorised personnel who review completed submissions.</li>
        </ul>
        <p>We never sell your personal data, and we do not share it with third parties for marketing.</p>
      </LegalSection>

      <LegalSection n="5" title="International transfers">
        <p>
          Your documents are stored in the London (europe-west2) region. Where a service provider processes
          limited data outside the UK (for example, email delivery infrastructure), we rely on UK-approved
          safeguards such as the UK International Data Transfer Agreement or UK Addendum to the EU Standard
          Contractual Clauses.
        </p>
      </LegalSection>

      <LegalSection n="6" title="How long we keep your data">
        <p>
          Signed agreements are contractual records and are retained for the duration of your engagement with
          PNC and for up to 6 years afterwards, in line with the limitation period for contractual claims in
          England and Wales. Full details are in our{' '}
          <a href="/security">Security &amp; Data Retention</a> policy.
        </p>
      </LegalSection>

      <LegalSection n="7" title="Your rights">
        <p>Under UK GDPR you have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you.</li>
          <li>Ask us to correct inaccurate data.</li>
          <li>Ask us to erase data where there is no lawful reason to keep it.</li>
          <li>Restrict or object to processing in certain circumstances.</li>
          <li>Receive a copy of your data in a portable format.</li>
        </ul>
        <p>
          To exercise any of these rights, contact <a href="mailto:admin@pncunique.com">admin@pncunique.com</a>.
          You also have the right to complain to the Information Commissioner&rsquo;s Office at{' '}
          <a href="https://ico.org.uk" target="_blank" rel="noreferrer">ico.org.uk</a> or on 0303 123 1113.
        </p>
      </LegalSection>

      <LegalSection n="8" title="Contact">
        <p>PNC UNIQUE LTD &middot; Headlands House, 1 Kings Court, Kettering Parkway, Kettering, Northamptonshire, NN15 6WJ.</p>
        <p><a href="mailto:admin@pncunique.com">admin@pncunique.com</a> &middot; 0333 090 5024 &middot; <a href="https://www.pncunique.com" target="_blank" rel="noreferrer">www.pncunique.com</a></p>
      </LegalSection>
    </LegalShell>
  );
}
